const reducerName = '@cityoo-backoffice/spatial/replayBooks';

export const RESET = `${reducerName}/RESET`;

export const RUN_PENDING_REPLAY_BOOKS_START = `${reducerName}/RUN_PENDING_REPLAY_BOOKS_START`;
export const RUN_PENDING_REPLAY_BOOKS_SUCCESS = `${reducerName}/RUN_PENDING_REPLAY_BOOKS_SUCCESS`;
export const RUN_PENDING_REPLAY_BOOKS_FAIL = `${reducerName}/RUN_PENDING_REPLAY_BOOKS_FAIL`;
